/**
 * ============================================================================
 * KFE — dashboard structure (spec multi-dashboard R4).
 * ============================================================================
 *
 * The default dashboard: the KFE program's WBR (the program was named FAI
 * until 2026-09 — spec dashboard-rename-kfe-quality, sim D532199531). The
 * wire id stays "fai" because every API payload and cache partition keys on
 * it; URL and display identity carry the new name. The Detailed Summary
 * page's tabs/sections live in the existing view config
 * (config/views/detailedSummaryView.json — unchanged).
 */

import detailedSummaryConfig from 'src/config/views/detailedSummaryView.json';
import { WbrView } from 'src/types';
import { DashboardStructure } from 'src/config/dashboards/types';
import { WBR_DASHBOARD_ID } from 'src/constants';

export const kfe: DashboardStructure = {
  // The legacy wire id ("fai") — see the structure's field docs.
  dashboardId: WBR_DASHBOARD_ID,
  urlName: 'kfe',
  displayName: 'KFE',
  pages: [
    { route: '/', title: 'Executive Summary', kind: 'home' },
    {
      route: '/customer-domains',
      title: 'Customer Domain Level Summary',
      kind: 'tiles',
    },
    {
      route: '/detailed-view',
      title: 'Detailed View',
      kind: 'view',
      view: detailedSummaryConfig as unknown as WbrView,
      // The one page where callouts/comments can be written (R1.7) — the
      // review runs against these tables; other pages read the same threads.
      calloutAuthoring: true,
    },
    {
      route: '/action-items',
      title: 'Action Items',
      kind: 'actionItems',
      // Gated on the ACTION_ITEMS feature lock (fail-closed tab + page).
      featureId: 'action_items',
    },
  ],
};
